import ExpandableVolumeSnippet from "../../../../contents/docs/self-host/_snippets/expandable-volume";
import * as React from 'react';
export default {
  ExpandableVolumeSnippet,
  React
};